<ng-template #noGroupsTmpl let-items [ngTemplateType]="ListTemplateContext">
  <div
    #filteredOptions
    *ngFor="let option of items; let itemIndex = index; let last = last; trackBy: trackByOption"
    [class.disabled]="option.disabled"
    [class.selected]="selectedOptionIndex === itemIndex"
    [hidden]="hideSelectedOption && selectedOption?.value === option.value"
    (click)="
      !option.disabled && selectOption(option); $event.preventDefault(); $event.stopPropagation()
    "
    class="item"
  >
    <div
      class="text"
      [class.padding-left]="itemTextLeftPadding"
      [class.no-padding]="itemTextNoPadding"
    >
      <ng-template
        [ngTemplateOutlet]="optionTemplate || optionDefaultTemplate"
        [ngTemplateOutletContext]="{ option: option }"
      >
      </ng-template>
    </div>
    <rt-divider *ngIf="hasDropdownSeparator && (!last || footerTemplate)"></rt-divider>
  </div>
</ng-template>

<ng-template #groupsTmpl let-items [ngTemplateType]="GroupsTemplateContext">
  <div *ngFor="let group of items; let first = first; trackBy: trackByGroup">
    <ng-template
      [ngTemplateOutlet]="groupHeaderTemplate || groupHeaderDefaultTemplate"
      [ngTemplateOutletContext]="{ group: group, first: first }"
    >
    </ng-template>

    <div
      #filteredOptions
      *ngFor="let option of group.options; let last = last; trackBy: trackByOption"
      [class.disabled]="option.disabled"
      [class.selected]="option.uuid === selectedItemUuid"
      (click)="
        !option.disabled && selectOption(option); $event.preventDefault(); $event.stopPropagation()
      "
      class="item group"
    >
      <div
        class="text"
        [class.padding-left]="itemTextLeftPadding"
        [class.no-padding]="itemTextNoPadding"
      >
        <ng-template
          [ngTemplateOutlet]="optionTemplate || optionDefaultTemplate"
          [ngTemplateOutletContext]="{ option: option }"
        >
        </ng-template>
      </div>
      <rt-divider *ngIf="hasDropdownSeparator && (!last || footerTemplate)"></rt-divider>
    </div>
  </div>
</ng-template>

<ng-template #defaultScrollTmpl let-items [ngTemplateType]="GroupsOrListTemplateContext">
  <ng-container
    [ngTemplateOutlet]="hasGroups ? groupsTmpl : noGroupsTmpl"
    [ngTemplateOutletContext]="{ $implicit: items }"
  ></ng-container>
</ng-template>

<ng-template #virtualScrollTmpl let-items [ngTemplateType]="GroupsOrListTemplateContext">
  <virtual-scroller
    #virtualScroll
    [bufferAmount]="5"
    [scrollAnimationTime]="0"
    [scrollThrottlingTime]="10"
    [enableUnequalChildrenSizes]="true"
    [executeRefreshOutsideAngularZone]="true"
    [items]="items"
    (vsUpdate)="onVirtualScrollUpdate($event)"
    [style.height.px]="hasSearch ? 210 : 270"
  >
    <ng-container
      [ngTemplateOutlet]="defaultScrollTmpl"
      [ngTemplateOutletContext]="{ $implicit: virtualScroll.viewPortItems }"
    ></ng-container>
  </virtual-scroller>
</ng-template>

<rt-label *ngIf="label">
  {{ label }}
</rt-label>

<div (keydown)="handleKeyDown($event)">
  <div #dropdownContainer #selectDropdownTrigger="rtOverlayOrigin" rt-overlay-origin>
    <div *ngIf="multiple && selectedOptions.length > 0" class="selected-labels">
      <div *ngFor="let option of selectedOptions; trackBy: trackByOption" class="selected-label">
        <ng-template
          [ngTemplateOutlet]="labelTemplate || labelDefaultTemplate"
          [ngTemplateOutletContext]="{
            option: option,
            removeValue: removeValue,
            wrapLabelText: wrapLabelText
          }"
        >
        </ng-template>
      </div>
    </div>

    <ng-template
      [ngTemplateOutlet]="triggerTemplate || triggerDefaultTemplate"
      [ngTemplateOutletContext]="{
        disabled: disabled,
        readOnly: readOnly,
        placeholder: placeholder,
        selectedOption: selectedOption,
        dropdownOpened: dropdownOpened,
        toggleDropdown: toggleDropdown,
        $implicit: triggerTemplateContext
      }"
    >
    </ng-template>
  </div>

  <ng-template
    #selectDropdownOverlay="rtConnectedOverlay"
    [origin]="selectDropdownTrigger"
    [positions]="dropdownPositions!"
    (backdropClick)="toggleDropdown(false)"
    rt-connected-overlay
    [hasBackdrop]="true"
  >
    <rt-select-dropdown
      [scrollTop]="scrollTop"
      [width]="minDropdownWidth || maxDropdownWidth ? null : dropdownWidth"
      [minWidth]="minDropdownWidth"
      [maxWidth]="maxDropdownWidth"
      [noMaxHeight]="noMaxHeight!"
      [footerTemplate]="footerTemplate"
      [footerTemplateContext]="footerTemplateContext"
      [hasStickyFooter]="hasStickyFooter!"
      [hasDivider]="hasDivider"
      [light]="light"
      [dark]="dark"
      [radiusDefault]="radiusDefault"
    >
      <ng-template>
        <rt-dropdown-header *ngIf="hasSearch">
          <rt-form-field (click)="$event.preventDefault()" class="context-default" margin-tb-small>
            <rt-input
              #searchQueryInput
              [value]="searchQuery"
              [autoFocus]="true"
              [hasClearButton]="true"
              (valueChange)="changeSearchQuery($event)"
              (keydown)="handleSearchInputKeydown($event)"
              variant="rounded"
              [placeholder]="searchPlaceholder || ('rtu.common.search' | translate)"
            >
              <rt-icon prefix name="search"></rt-icon>
            </rt-input>
          </rt-form-field>
        </rt-dropdown-header>

        <div [style.max-height.px]="hasSearch ? 210 : 270" class="scroll-container">
          <ng-container
            [ngTemplateOutlet]="
              virtualScrollEnabled && virtualScrollThresholdExceeded
                ? virtualScrollTmpl
                : defaultScrollTmpl
            "
            [ngTemplateOutletContext]="{
              $implicit: hasGroups ? filteredGroupsOptions : filteredOptions
            }"
          ></ng-container>
        </div>

        <rt-dropdown-item *ngIf="!filteredOptions.length && !filteredGroupsOptions.length">
          {{ noResultsMessage }}
        </rt-dropdown-item>

        <ng-template
          *ngIf="!hasStickyFooter"
          [ngTemplateOutlet]="footerTemplate || footerDefaultTemplate"
        >
        </ng-template>
      </ng-template>
    </rt-select-dropdown>
  </ng-template>
</div>

<ng-template
  #triggerDefaultTemplate
  let-disabled="disabled"
  let-readOnly="readOnly"
  let-placeholder="placeholder"
  let-selectedOption="selectedOption"
  let-dropdownOpened="dropdownOpened"
  let-toggleDropdown="toggleDropdown"
  [ngTemplateType]="TriggerTemplateContext"
>
  <rt-button
    #trigger
    *ngIf="!hasInputTrigger"
    [class.dropdownOpened]="dropdownOpened"
    [disabled]="disabled || readOnly"
    [attr.tabindex]="disabled ? null : tabIndex || null"
    (click)="!disabled && !readOnly && toggleDropdown(true)"
    variant="secondary"
    [dropdownOpened]="dropdownOpened"
  >
    <div layout layout-full-width layout-space-between>
      <!-- SECURITY: Right now we allow any html in here... but maybe we'll change it in the future? -->
      <span
        *ngIf="!(selectedOption && selectedOption.value && selectedOption.label)"
        [innerHTML]="placeholder"
        [class.placeholder-bold]="boldPlaceholder"
        class="select-placeholder"
      >
      </span>
      <span *ngIf="selectedOption && selectedOption.value && selectedOption.label">
        <ng-container *ngIf="selectedOptionIconLeft">
          <div layout-horizontal layout-align-items-center>
            <rt-icon [name]="selectedOptionIconLeft" margin-right-small-x></rt-icon>
            <rt-truncate>{{ selectedOption.label }}</rt-truncate>
          </div>
        </ng-container>
        <ng-container *ngIf="!selectedOptionIconLeft">
          <rt-truncate>{{ selectedOption.label }}</rt-truncate>
        </ng-container>
      </span>
    </div>
  </rt-button>

  <rt-input
    #trigger
    *ngIf="hasInputTrigger"
    [disabled]="disabled"
    [readOnly]="true"
    [placeholder]="placeholder"
    [tabIndex]="tabIndex"
    [hasDropdownIndicator]="true"
    [class.dropdownOpened]="dropdownOpened"
    [value]="
      labelOverride
        ? labelOverride
        : multiple
        ? ''
        : selectedOption.value && selectedOption.label
        ? selectedOption.label
        : ''
    "
    [invalid]="isInvalid"
    (click)="!disabled && !readOnly && !dropdownOpened && toggleDropdown(true)"
    variant="rounded"
  >
  </rt-input>
</ng-template>

<ng-template
  #optionDefaultTemplate
  let-option="option"
  [ngTemplateType]="SelectOptionContext"
  ngPreserveWhitespaces
>
  <span
    [attr.padding-left-small-x]="hasItemPadding ? '' : null"
    [attr.text-default]="option.count === 0 || undefined"
    [attr.text-medium]="option.count !== 0 || undefined"
    [class.word-break]="optionWordBreak"
  >
    <span
      *ngIf="includeEmptyOption && iconEmptyLabel && option.value === ''; else textLabel"
      class="empty-label-icon"
    >
      <rt-icon name="remove"></rt-icon>
    </span>
    <ng-template #textLabel>
      {{ option.label }}
    </ng-template>
  </span>
  <span *ngIf="option.count !== undefined && option.count !== null" text-default
    >({{ option.count }})
  </span>
</ng-template>

<ng-template
  #labelDefaultTemplate
  let-option="option"
  let-removeValue="removeValue"
  let-wrapLabelText="wrapLabelText"
  [ngTemplateType]="LabelTemplateContext"
>
  <rt-tag
    [name]="option.label"
    [wrapText]="wrapLabelText"
    [deletable]="true"
    [counter]="option.count"
    [isClickable]="false"
    [isHoverable]="false"
    (deleteClick)="removeValue(option.value!)"
  >
  </rt-tag>
</ng-template>
<ng-template
  #groupHeaderDefaultTemplate
  let-group="group"
  let-first="first"
  [ngTemplateType]="GroupHeaderTemplateContext"
>
  <rt-heading
    *ngIf="group.title"
    variant="subheading uppercased text-color-light"
    margin-lr-small
    margin-top
  >
    {{ group.title }}
  </rt-heading>
</ng-template>

<ng-template #footerDefaultTemplate></ng-template>
